import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from './../../../../@AppService/Services/loader-service.service';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [TranslatePipe, RouterModule, CommonModule],
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss',
})
export class NoDataComponent implements OnInit {
  constructor(private LoadingService: LoadingService) {}
  @Input() title!: string;
  @Input() message!: string;
  @Input() img!: string;
  @Input() isButton: boolean = true;
  ngOnInit() {
    this.LoadingService.isError.subscribe((res) => {
      // this.title = res ? 'Error 500' : 'no data found!';
    });
  }
}
